import { apiV1 } from './api';

export const getConstants = () => apiV1.get('/missions/constants');
